<template>
  <div class="expiration-reminder">
    <!-- <Button class="expiration-reminder__back" @click="goBack">
      <i class="iconfont icon-zuojiantou"></i>
      返回
    </Button> -->
    <div class="expiration-reminder__content">
      <img src="@/assets/img/expirationReminder.webp" alt="">
      <div class="expiration-reminder__content__title">{{statusModel.title}}</div>
      <p class="expiration-reminder__content__desc">{{ statusModel.info }}</p>
      <div class="expiration-reminder__content__btns">
        <!--<Button type="primary" v-show="!isSuper">联系管理员</Button>-->
        <Button type="primary" @click="goCostCenter" v-show="isSuper">去费用中心</Button>
        <span class="close-btn" @click="goBack" v-show="statusModel.type === '2'">知道了</span>
      </div>
    </div>
  </div>
</template>
<script>
import Cookies from 'js-cookie';
import moment from 'moment';
export default {
  name: 'ExpirationReminder',
  props: {
    title: {
      type: String,
      default: ''
    }
  },
  computed: {
    isSuper() {
      //判断是否为root
      return this.$system.$auth.isSuper();
    },
    costCenterUrl(){
      if(window.location.host.includes('test')){
        return 'https://cost.wandianzhang.com/#/?token='+ccutils.getToken();
      }else{
        return 'https://cost.ovopark.com/#/?token='+ccutils.getToken();
      }
    }
  },
  data () {
    return {
      titleText: this.title,
      productEnum:{
        INTERNAL_TRAINING: '培训产品',
      },
      statusList:[
        {
          type: '1',
          title: '应用未激活',
          desc: (productName)=>{
            return `企业管理员未在万店掌为您激活 ${productName} ，如需使用，请联系您所在企业的管理员`;
          },
          superDesc: (productName)=>{
            return `您当前未在万店掌激活 ${productName} ，如需使用，请至费用中心购买/激活`;
          },
        },
        {
          type: '2',
          title: '应用即将到期',
          desc: (productName, eTime)=>{
            return `企业管理员在万店掌为您开通的 ${productName} 即将过期（到期日：${eTime}），到期未续费将无法使用，请联系您所在企业的管理员`;
          },
          superDesc: (productName, eTime)=>{
            return `您当前在万店掌开通的 ${productName} 即将过期（到期日：${eTime}），到期未续费将无法使用，请至费用中心购买/激活`;
          },
        },
        {
          type: '3',
          title: '应用无法使用',
          desc: (productName, eTime)=>{
            return `企业管理员在万店掌为您开通的 ${productName} 已过期（到期日：${eTime}），如需使用，请联系您所在企业的管理员`;
          },
          superDesc: (productName, eTime)=>{
            return `您当前在万店掌开通的 ${productName} 已过期（到期日：${eTime}），如需使用，请至费用中心购买/激活`;
          },
        }
      ],
      statusModel: {}
    }
  },
  watch: {
    title (val) {
      this.titleText = val
    }
  },
  created () {
    let expirationReminder = Cookies.get('ovo_expirationReminder') || '{}';
    expirationReminder = JSON.parse(expirationReminder);
    console.log('expirationReminder',expirationReminder);
    let eTime = expirationReminder.eTime;
    let productName = expirationReminder.productName;
    let now = new Date().getTime();
    let status = {};
    if(!eTime){
      status = this.statusList[0];
    }else if(eTime>now){
      status = this.statusList[1];
    }else{
      status = this.statusList[2];
    }
    if(eTime){
      eTime = moment(eTime).format('YYYY年MM月DD日');
    }
    if(this.isSuper){
      status.info = status.superDesc(this.productEnum[productName], eTime);
    }else{
      status.info = status.desc(this.productEnum[productName], eTime);
      if(expirationReminder.name){
        status.info += `:${expirationReminder.name}`;
      }
      if(expirationReminder.phone){
        status.info += ` ${expirationReminder.phone}`;
      }
    }
    this.statusModel = status;
  },
  methods: {
    goCostCenter(){
      window.open(this.costCenterUrl, '_blank');
    },
    goBack(){
      this.$router.go(-1);
    }
  }
}
</script>
<style lang="scss">
.expiration-reminder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  &__back{
    position: absolute;
    top:0px;
    left:20px;
    >span{
      display: flex;
      align-items: center;
      i{
        margin-right: 6px;
      }
    }
  }
  &__content {
    width: 100%;
    margin-top: 10%;
    text-align: center;
    img{
      width: 88px;
      height: auto;
    }
    &__title{
      font-weight: 600;
      font-size: 18px;
      margin: 16px 0;
    }
    p{
      color: #595959;
      font-size: 14px;
    }
    &__btns{
      margin-top: 80px;
      button{
        height: 44px;
        padding: 0 40px;
        font-size: 16px;
        font-weight: 600;
        border-radius: 8px;
      }
      .close-btn{
        margin-top: 12px;
        display: block;
        padding: 12px;
        font-weight: 400;
        font-size: 16px;
        color: #B2B2B2;
        cursor: pointer;
      }
    }
  }
}
</style>
